import {SearchableItemService} from "../../../services/SearchableItemService";
import {textFilterParamsValues} from "../reactTableController";
export const defaultSortModel = [
    {
        colId: 'saldoDate',
        sort: 'asc',
        sortIndex: 0
    }
];
export const reactValueSeriesCols = function ( translate, userService, tabName) {
    const filterFormatter = userService.filterFormatter;
    return [ {
        field: "saldoDate",
        headerName: translate.instant('VALUE_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateNoLocal')( params.data.saldoDate) : "";
        }
    },{
        field: "shortName",
        headerName: translate.instant('ACCOUNT_NAME'),
        sortable: true,
        filter: tabName === 'loadKey' ? false : 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "accountNumber",
        headerName: translate.instant('ACCOUNT_NUMBER'),
        sortable: true,
        filter: tabName === 'loadKey' ? false : 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "bank",
        headerName: translate.instant('BANK'),
        sortable: true,
        filter: (tabName === 'bank' || tabName === 'loadKey') ? false : "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bank'])
                    .then(data => params.success(data.map(it => it.name)));
            }}
    },{
        field: "countryName",
        headerName: translate.instant('COUNTRY'),
        sortable: true,
        filter:  (tabName === 'country' || tabName === 'loadKey') ? false : "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['country'])
                    .then(data => params.success(data.map(it => it.name)));
            }}
    },{
        field: "currencyCode",
        headerName: translate.instant('CURRENCY'),
        sortable: true,
        filter:  (tabName === 'currency' || tabName === 'loadKey') ? false : "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['currency'])
                    .then(data => params.success(data.map(it => it.code)));
            }}
    },{
        field: "oriDiff",
        headerName: translate.instant('ENTRIES_AMNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ? filterFormatter('fsNumber')( params.data.oriDiff, 2) : "";
        },
        type: 'numericColumn'
    },{
        field: "oriDiffWithPre",
        headerName: translate.instant('PRENOTATION_AMNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ? filterFormatter('fsNumber')( params.data.oriDiffWithPre, 2) : "";
        },
        type: 'numericColumn'
    },{
        field: "oriValueAmount",
        headerName: translate.instant('VALUE_AMNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ? filterFormatter('fsNumber')( params.data.oriValueAmount, 2) : "";
        },
        type: 'numericColumn'
    },{
        field: "oriValAmountWithPrenot",
        headerName: translate.instant('VALUE_PRENOTATION_AMNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ? filterFormatter('fsNumber')( params.data.oriValAmountWithPrenot, 2) : "";
        },
        type: 'numericColumn'
    },{
        field: "oriDiffWithForecast",
        headerName: translate.instant('FORECAST_AMNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ? filterFormatter('fsNumber')( params.data.oriDiffWithForecast, 2) : "";
        },
        type: 'numericColumn'
    },{
        field: "oriValAmountWithForecast",
        headerName: translate.instant('VALUE_FORECAST_AMNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ? filterFormatter('fsNumber')( params.data.oriValAmountWithForecast, 2) : "";
        },
        type: 'numericColumn'
    }, {
        field: "accSaldoDate",
        headerName: translate.instant('ACCOUNT_BALANCE_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateNoLocal')( params.data.accSaldoDate) : "";
        },
        initialHide: true
    }, {
        field: "accSaldoAmount",
        headerName: translate.instant('ACCOUNT_BALANCE'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ? filterFormatter('fsNumber')( params.data.accSaldoAmount, 2) : "";
        },
        type: 'numericColumn',
        initialHide: true
    }];
}
